import React from 'react';
import { Button } from '../components';

class MenuItem extends React.Component {

    getClickHandler() {
        if (typeof this.props.onClick === 'function') {
            return event => {
                event.preventDefault();

                if (typeof this.props.onClick === 'function') {
                    this.props.onClick(event, this.props.itemId);
                }
            }
        } else {
            return undefined;
        }
    }

    render () {
        let to = this.props.href;
        let classes = ['component-menu-item', this.props.className];
        let contents = this.props.text || this.props.children;

        if (this.props.active) {
            classes.push('active');
        }

        return (
            <Button { ...this.props } onClick={ this.getClickHandler() } className={classes.join(' ')} to={to}>
                {contents}
            </Button>
        )
    }
}

export default MenuItem;



// WEBPACK FOOTER //
// ./web-app/components/menu-item.jsx